<template>
  <div>
    <b-card>
      <div class="row d-flex mb-3 justify-content-between align-items-center">
        <h4 class="col-12 col-xl-auto mb-2 mb-xl-0 font-weight-bold">
          聯絡人管理<span v-if="ownerName"> - {{ ownerName }}</span>
        </h4>
        <div class="col-12 col-xl-auto d-flex flex-wrap">
          <b-button
            class="mb-2 mb-xl-0 mr-2"
            variant="link"
            :to="{ name: 'CustomerList' }"
          >
            <i class="fa fa-chevron-left"></i> 返回會員列表
          </b-button>
          <b-button
            v-if="$permissions.has($permissions.consts.CONTACT_CREATE)"
            class="mb-2 mb-xl-0"
            variant="primary"
            :to="{ name: 'CustomerContactCreate', params: { customerID } }"
          >
            <i class="fa fa-plus"></i> 新增聯絡人
          </b-button>
        </div>
      </div>

      <b-overlay :show="isLoading" rounded="sm">
        <b-table
          striped
          hover
          responsive
          :items="contacts"
          :fields="fields"
          :busy="isLoading"
        >
          <template #cell(actions)="data">
            <b-button
              v-if="$permissions.has($permissions.consts.CONTACT_MODIFY)"
              variant="inverse-warning"
              class="mr-1"
              :to="{
                name: 'CustomerContactEdit',
                params: { customerID, contactID: data.item.id },
              }"
            >
              <span class="mdi mdi-lead-pencil"></span> 編輯
            </b-button>
            <b-button
              v-if="$permissions.has($permissions.consts.CONTACT_DELETE)"
              variant="inverse-danger"
              @click="handleDelete(data.item)"
            >
              <span class="mdi mdi-delete"></span> 刪除
            </b-button>
          </template>
        </b-table>
      </b-overlay>

      <CustomPagination
        :currentPage="query.page"
        :totalRows="totalRows"
        :perPage="query.per_page"
        @page-change="handlePageChange"
        @per-page-change="handlePerPageChange"
      />
    </b-card>
  </div>
</template>

<script>
import moment from "moment";
import contactApi from "@/apis/contact";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import { paginationMixin } from "@/mixins/pagination";

const SEXUAL_TEXT = { male: "男", female: "女" };

export default {
  components: { CustomPagination },
  mixins: [paginationMixin],
  data() {
    return {
      isLoading: false,
      totalRows: 0,
      ownerName: "",
      contacts: [],
      fields: [
        { key: "owner_customer_name", label: "擁有人" },
        { key: "name", label: "聯絡人姓名" },
        { key: "relationship", label: "關係" },
        { key: "mobile_phone", label: "手機號碼" },
        { key: "birthday", label: "生日" },
        {
          key: "sexual",
          label: "性別",
          formatter: (value) => SEXUAL_TEXT[value] || "未設定",
        },
        {
          key: "created_at",
          label: "建立日期",
          formatter: (value) =>
            value ? moment(value).format("YYYY-MM-DD HH:mm") : "",
        },
        {
          key: "updated_at",
          label: "更新日期",
          formatter: (value) =>
            value ? moment(value).format("YYYY-MM-DD HH:mm") : "",
        },
        { key: "actions", label: "操作" },
      ],
      query: {
        page: 1,
        per_page: 10,
      },
    };
  },
  computed: {
    customerID() {
      return this.$route.params.customerID;
    },
  },
  watch: {
    "query.page": "fetchContacts",
    "query.per_page": "fetchContacts",
  },
  created() {
    this.fetchContacts();
  },
  methods: {
    async fetchContacts() {
      try {
        this.isLoading = true;
        const { data } = await contactApi.list(this.customerID, {
          page: this.query.page,
          per_page: this.query.per_page,
        });
        this.contacts = data.data;
        this.totalRows = data.meta ? data.meta.total : data.data.length;
        if (data.data.length && data.data[0].owner_customer_name) {
          this.ownerName = data.data[0].owner_customer_name;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    handleDelete(contact) {
      this.$swal
        .fire({
          type: "warning",
          title: "你確定要刪除嗎？",
          html: `<div class="my-3">聯絡人：${contact.name}</div>`,
          confirmButtonText: "確定刪除",
          cancelButtonText: "不刪除",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (!result.value) return;
          try {
            this.isLoading = true;
            await contactApi.delete(contact.id);
            await this.fetchContacts();
            this.$swal.fire({ type: "success", text: `成功刪除 ${contact.name}` });
          } catch (error) {
            console.log(error);
          } finally {
            this.isLoading = false;
          }
        });
    },
  },
};
</script>
